import { Address, Card, Payer, SessionResponse } from '@finteqhub/sdk-js';

import { PayLoadValue } from '@cashier/cashier-model';

interface FormAccountPayload {
  customerAccountId: string;
  credentials: {
    card: {
      cvv: string;
    };
    payer: Payer;
    billingAddress: Address;
  };
  paymentMethod: string;
}

interface FormStandardPayload {
  credentials: {
    card: Card;
    payer?: Payer;
    billingAddress?: Address;
  };
  paymentMethod: string;
}

export const DataConverter = {
  toFormPayload: (
    session: SessionResponse,
    payload: { [name: string]: { value: PayLoadValue } },
    externalAccountId?: string,
  ): FormAccountPayload | FormStandardPayload => {
    if (externalAccountId) {
      return {
        customerAccountId: externalAccountId,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        credentials: {
          card: {
            cvv: String(payload['cvv'].value),
          },
          payer: session.initCredentials.payer,
          billingAddress: session.initCredentials.billingAddress,
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        paymentMethod: session.operation['paymentMethod'] || '',
      };
    }

    const [cardExpireMonth, cardExpireYear] = (
      payload['expirationDate'].value as string
    ).split('/');

    return {
      credentials: {
        card: {
          number: String(payload['creditcardNumber'].value),
          holder: String(payload['cardHolder'].value),
          expiryMonth: Number(cardExpireMonth),
          expiryYear: Number(cardExpireYear),
          cvv: String(payload['cvv'].value),
          tokenize: true,
        },
        payer: session.initCredentials.payer,
        billingAddress: session.initCredentials.billingAddress,
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      paymentMethod: session.operation['paymentMethod'] || '',
    };
  },
};
